import { gql } from 'graphql-tag';

export const GET_ALL_FORMS_FOR_CURRENT_USER = gql`
  query GetAllFormsForCurrentUser {
    forms {
      id
      title
      openDate
      closeDate
      templateVersionId
      targets {
        targetDepartments
        targetDepartmentsForResponses
        targetDepartmentsForTextResponses
        targetManagementRoles {
          id
          name
        }
        targetManagementRolesForResponses {
          id
          name
        }
        targetManagementRolesForTextResponses {
          id
          name
        }
        targetIndividuals
        targetIndividualsForResponses
        targetIndividualsForTextResponses
        addResponseEmailRecipients
        addResponseTextRecipients
        addTargetManagementRoles
        shouldSendConfirmationEmailToFormSubmitter
        shouldSendConfirmationSmsToFormSubmitter
      }
      isAnonymous
      isPasscodeRequired
      isArchived
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const GET_FORM_BY_ID_AND_COMPANY_ID = gql`
  query GetFormByIdAndCompanyId($id: ID!, $friendlyCompanyId: String!) {
    formByIdAndCompanyIdNoAuth(id: $id, friendlyCompanyId: $friendlyCompanyId) {
      id
      title
      openDate
      closeDate
      templateVersionId
      targets {
        targetDepartments
        targetDepartmentsForResponses
        targetDepartmentsForTextResponses
        targetManagementRoles {
          id
          name
        }
        targetManagementRolesForResponses {
          id
          name
        }
        targetManagementRolesForTextResponses {
          id
          name
        }
        targetIndividuals
        targetIndividualsForResponses
        targetIndividualsForTextResponses

        addResponseEmailRecipients
        addResponseTextRecipients
        addTargetManagementRoles
        shouldSendConfirmationEmailToFormSubmitter
        shouldSendConfirmationSmsToFormSubmitter
      }
      isAnonymous
      isPasscodeRequired
      isArchived
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const GET_OPEN_FORMS_FOR_EMPLOYEE_AND_COMPANY_NO_AUTH = gql`
  query GetOpenFormsForEmployeeAndCompanyNoAuth(
    $friendlyCompanyId: String!
    $employeeId: String!
  ) {
    openFormOptionsNoAuth(
      friendlyCompanyId: $friendlyCompanyId
      employeeId: $employeeId
    ) {
      label
      id
      extra
    }
  }
`;

export const UPDATE_FORM = gql`
  mutation UpdateForm($id: ID!, $input: FormInput!) {
    updateForm(id: $id, input: $input) {
      id
      title
      openDate
      closeDate
      templateVersionId
      targets {
        targetDepartments
        targetDepartmentsForResponses
        targetDepartmentsForTextResponses
        targetManagementRoles {
          id
          name
        }
        targetManagementRolesForResponses {
          id
          name
        }
        targetManagementRolesForTextResponses {
          id
          name
        }
        targetIndividuals
        targetIndividualsForResponses
        targetIndividualsForTextResponses
        addResponseEmailRecipients
        addResponseTextRecipients
        shouldSendConfirmationEmailToFormSubmitter
        shouldSendConfirmationSmsToFormSubmitter
        addTargetManagementRoles
      }
      isAnonymous
      isPasscodeRequired
      isArchived
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const ADD_FORM = gql`
  mutation AddForm($input: CreateFormInput!) {
    createForm(input: $input) {
      id
      title
      openDate
      closeDate
      templateVersionId
      targets {
        targetDepartments
        targetDepartmentsForResponses
        targetDepartmentsForTextResponses
        targetManagementRoles {
          id
          name
        }
        targetManagementRolesForResponses {
          id
          name
        }
        targetManagementRolesForTextResponses {
          id
          name
        }
        targetIndividuals
        targetIndividualsForResponses
        targetIndividualsForTextResponses
        addResponseEmailRecipients
        addResponseTextRecipients
        shouldSendConfirmationEmailToFormSubmitter
        shouldSendConfirmationSmsToFormSubmitter
        addTargetManagementRoles
      }
      isAnonymous
      isPasscodeRequired
      isArchived
      ownerId
      companyId
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FORM = gql`
  mutation DeleteForm($formId: ID!) {
    deleteForm(id: $formId)
  }
`;

/**
 * How many active employees each target would invite, counted on the server
 * with the same rule the send-out uses. With `emailTargetIndexes`, also how
 * many saving would email now, less anyone who has completed `formId`.
 */
export const GET_TARGET_AUDIENCE_COUNTS = gql`
  query GetTargetAudienceCounts(
    $targets: [TargetInput!]!
    $emailTargetIndexes: [Int!]
    $formId: ID
  ) {
    targetAudienceCounts(
      targets: $targets
      emailTargetIndexes: $emailTargetIndexes
      formId: $formId
    ) {
      perTarget
      unreachablePerTarget
      total
      emailTotal
      emailUnreachable
    }
  }
`;

/** Who one target reaches, people whose email is unlikely to arrive first. */
export const GET_TARGET_AUDIENCE = gql`
  query GetTargetAudience($target: TargetInput!) {
    targetAudience(target: $target) {
      id
      employeeId
      firstName
      lastName
      emailAddress
      emailProblem
    }
  }
`;
